<template>
  <!-- template for the modal component -->
  <div type="text/x-template" id="modal-template">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <slot name="header">
                <h3>CONDITIONS GENERALES D’UTILISATION DU SITE</h3>
              </slot>
            </div>

            <div class="modal-body">
              <slot name="body">
                <p>
                  Les présentes conditions générales d’utilisation de notre
                  application sont applicables à toute personne naviguant sur
                  ladite application.
                </p>

                <h3>ACCES A L’APPLICATION</h3>
                <p>
                  Cette application n’est accessible qu’aux salariés des
                  entreprises qui ont souscrit un abonnement d’un an
                  renouvelable à notre application.
                </p>
                <p>
                  L’employeur a souscrit un abonnement destiné aux salariés de
                  son entreprise, en qualité d’utilisateurs.
                </p>
                <p>
                  Les utilisateurs pourront ainsi bénéficier, s’ils le
                  souhaitent, d’un accès à des exercices adaptés, ayant pour
                  vocation à prévenir les troubles musculo-squelettiques dans
                  l’entreprise.
                </p>
                <p>
                  Le site est accessible à tout utilisateur détenant une
                  autorisation d’accès 24/24h et 7/7j, sauf interruption
                  programmée par la société ASIC ou interruption inopportune
                  liée à une nécessité de maintenance de l’application, à sa
                  sécurité ou cas de force majeure (évènement extérieur
                  imprévisible et insurmontable, qui exonère les parties de
                  leurs responsabilités respectives).
                </p>
                <p>
                  La société ASIC ne pourra être tenue responsable de problèmes
                  de transmission de données, de connexion ou d’indisponibilité
                  du réseau ni de dommages résultant d’une indisponibilité de
                  l’application.
                </p>
                <p>
                  La société ASIC se réserve le droit de faire évoluer
                  l’application, pour des raisons techniques ou commerciales.
                  L’utilisateur de l’application s’engage à ne pas tenter de
                  nuire au bon fonctionnement de l’application.
                </p>
                <h3>INSCRIPTION SUR LE SITE</h3>
                <p>
                  La création d’un compte sur l’application par l’utilisateur
                  n’est nécessaire que s’il souhaite bénéficier des exercices
                  proposés par l’application.
                </p>
                <p>
                  L’employeur adresse à l’utilisateur une invitation sur son
                  mail professionnel ou à défaut son mail personnel l’invitant à
                  s’inscrire à l’application grâce à un code d’accès
                  individualisé. Ce code d’accès permet à l’utilisateur la
                  création de son profil.
                </p>
                <p>
                  Chaque création de compte par un utilisateur correspond à une
                  licence acquise par son employeur pour bénéficier d’une
                  autorisation d’accès individualisée à l’application.
                </p>
                <p>
                  Chaque compte est anonyme. L’utilisateur devra se créer un
                  identifiant et un mot de passe qui seront conservés
                  exclusivement par la société ASIC et son développeur.
                </p>
                <p>
                  L’utilisateur ne peut être titulaire que d’un seul compte.
                </p>
                <p>
                  Lors de la création de son compte, l’utilisateur doit répondre
                  à un questionnaire qui lui permettra d’accéder à des exercices
                  adaptés à sa condition physique. Ce questionnaire est divisé
                  en 6 parties auxquelles l’utilisateur s’engage à répondre avec
                  sérieux.
                </p>
                <p>
                  L’utilisateur doit s’assurer de l’exactitude des données qu’il
                  fournit afin de lui permettre de bénéficier d’un accès à des
                  exercices adaptés. L’utilisateur devra mettre à jour
                  annuellement ses informations personnelles.
                </p>
                <p>
                  Le compte est exclusivement personnel et ne peut être ni
                  utilisé ni cédé à un tiers.
                </p>
                <p>
                  Si l’utilisateur oublie son mot de passe, il peut en demander
                  la réinitialisation.
                </p>
                <p>
                  L’identifiant et le mot de passe donnent uniquement un accès à
                  l’application permettant de suivre le programme d’exercices
                  individualisé proposé à l’utilisateur.
                </p>
                <p>
                  Pour les « animateurs relai » l’identifiant et le mot de passe
                  donnera accès au cours mis en ligne et à l’intégralité des
                  descriptions de chaque exercice (buts, actions, précautions,
                  variantes).
                </p>
                <h3>LE PROGRAMME</h3>
                <p>
                  ASIC propose à l’utilisateur un programme d’exercices
                  spécifiques liés à son métier selon trois niveaux adaptés à sa
                  condition physique.
                </p>
                <p></p>
                <p>
                  Les tests effectués lors de son inscription par l’utilisateur
                  permettront de proposer à l’utilisateur un des trois niveaux
                  de programmes suivants : débutant, intermédiaire, confirmé.
                </p>
                <p>
                  Chaque programme d’exercice consiste en une vidéo de
                  quarante-cinq secondes. L’utilisateur pourra chaque jour
                  effectuer le nombre d’exercice de son choix.
                </p>
                <p>
                  Il lui sera proposé d’indiquer une appréciation sur les
                  exercices proposés afin d’affiner son programme personnalisé.
                </p>
                <h3>DUREE DU PROGRAMME</h3>
                <p>
                  L’utilisateur bénéficie de l’utilisation de l’application pour
                  la durée souscrite par l’employeur. Si l’utilisateur ne
                  souhaite plus bénéficier de l’application, il pourra se
                  désinscrire à tout moment.
                </p>
                <h3>PROPRIETE INTELLECTUELLE</h3>
                <p>
                  Les marques, logos, signes ainsi que tous les contenus de
                  l’application (textes, images, son…) font l’objet d’une
                  protection par le code de la propriété intellectuelle et plus
                  particulièrement par le droit d’auteur. L’utilisateur doit
                  solliciter l’autorisation préalable de la société ASIC pour
                  toute reproduction, publication, copie des différents
                  contenus. Il s’engage à une utilisation des contenus du site
                  dans un cadre strictement privé. Toute utilisation à des fins
                  commerciales et publicitaires et strictement interdite. Toute
                  représentation totale ou partielle de l’application par
                  quelque procédé que ce soit, sans l’autorisation expresse de
                  la société ASIC constituerait une contrefaçon sanctionnée par
                  l’article L.335-2 et suivants du code de la propriété
                  intellectuelle.
                </p>
                <p>
                  Il est rappelé conformément à l’article L.122-5 du code de la
                  propriété intellectuelle, que l’utilisateur qui reproduit,
                  copie ou publie le contenu protégé doit citer l’auteur et sa
                  source.
                </p>
                <h3>RESPONSABILITE</h3>
                <p>
                  Il est rappelé que les exercices proposés par la société ASIC
                  sont exclusivement liés au bien-être, et à ce titre n’ont
                  aucune vertu thérapeutique. Les mouvements réalisés par
                  l’utilisateur sont réalisés sous sa seule responsabilité.
                  Aucun recours ne pourra être engagé à l’encontre de la société
                  ASIC à ce titre.
                </p>
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                <button
                  class="modal-default-button valider"
                  @click="postInfo(true)"
                >
                  Valider les Conditions
                </button>
                <button
                  class="modal-default-button pasValider"
                  @click="postInfo()"
                >
                  Ne pas les accepter
                </button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { hostUrl } from "../_helpers/global_var";
const axios = require("axios").default;

export default {
  name: "CGU",
  props: {
    close: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    postInfo(ok = null) {
      if (ok !== null) {
        try {
          let user = JSON.parse(localStorage.user);
          axios

            .get(hostUrl + "/salarie/addDateCgu/" + user.salarie_id)
            .then(
              response =>
                function() {
                  this.$emit("passOk");
                  this.$emit("close");
                }
            )
            .catch(error => console.log(error));

          this.$emit("passOk");
          this.$emit("close");
        } catch (error) {
          this.$emit("close");
          console.log(error);
        }
      } else {
        this.$emit("passPasOk");
        this.$emit("close");
      }
    }
  }
};
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 350px;
  max-height: 80vh;
  overflow-y: auto;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
@media screen and (max-width: 380px) {
  .modal-container {
    width: 70%;
  }
}

.modal-header h3 {
  margin-top: 0;
  /*color: #42b983;*/
  color: #54c7da;
  text-align: center;
}
.modal-body h3 {
  text-align: left;
  text-decoration: underline;
}
.modal-body p {
  text-align: left;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}
.valider {
  outline: none;
  font-weight: bold;
  color: white;
  background-color: #54c7da;
  border: none;
  border-radius: 15px;
  height: 40px;
  margin-top: 10px;
}
.valider:hover,
.valider:focus,
.valider:visited,
.valider:active {
  outline: none;
  border: 2px solid #473334;
}
.pasValider {
  outline: none;
  font-weight: bold;
  color: white;
  border: none;
  background-color: #c41316;
  border-radius: 15px;
  height: 40px;
  margin-top: 10px;
}
.pasValider:hover,
.pasValider:focus,
.pasValider:visited,
.pasValider:active {
  outline: none;
  border: 2px solid #473334;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}
.modal-footer {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/CGU.vue